import { render, staticRenderFns } from "./sync.vue?vue&type=template&id=9bae9de4&scoped=true"
import script from "./sync.vue?vue&type=script&lang=js"
export * from "./sync.vue?vue&type=script&lang=js"
import style0 from "./sync.vue?vue&type=style&index=0&id=9bae9de4&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bae9de4",
  null
  
)

export default component.exports